import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-wtaetigkeit-list-view',
  imports: [],
  templateUrl: './wtaetigkeit.list-view.html',
  styleUrls: ['./wtaetigkeit.list-view.css'],
})
export class WtaetigkeitListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
